import { useState, useEffect, useCallback } from "react";
import { costsService } from "@/api/services/costs.service";
/**
 * Fetches cost groups from Cost Settings API.
 * Used by quote report views to resolve section descriptions for Scope of Works.
 */
export function useCostGroups() {
    const [costGroups, setCostGroups] = useState(null);
    const [loading, setLoading] = useState(true);
    const fetch = useCallback(async () => {
        setLoading(true);
        try {
            const response = await costsService.getGroups();
            setCostGroups(response.data ?? null);
        }
        catch (err) {
            console.error("Error fetching cost groups:", err);
            setCostGroups(null);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetch();
    }, [fetch]);
    return { costGroups, loading, refetch: fetch };
}
